import { VectorLayer } from './Layer';
import { DevDataService } from '../model/DevDataService';
import { outlineRegion, outlineRegionLow } from './MapVectorStyles.js';
import { useEffect, useState } from 'react';
import { convertGeometryToFeatures } from '../controller/LayerQueries';
import { mergeJsonByRegion, filterJsonByStates } from '../model/mergeFeatures';

const RegionLayer = (props) => {
    const { map, zoom, zIndex, reportLoadStatus = () => {}, downloadRegion } = props;
    const [features, setFeatures] = useState([]);
    const [loadStatus, setLoadStatus] = useState(1);
    const [style, setStyle] = useState(null);

    useEffect(() => reportLoadStatus(loadStatus), [loadStatus]);

    //Default: Convert all states to features
    const allStateFeatures = (json) => {
        return convertGeometryToFeatures(json, 'topojson');
    };
    //Filter states by abbreviation list, then convert to features
    const filteredStateFeatures = (json, stateAbbrArr = ['GA']) => {
        var statesJson = filterJsonByStates(json, stateAbbrArr);
        return convertGeometryToFeatures(statesJson, 'topojson');
    };
    //Convert state features to outlined regions
    const mergedRegionFeatures = (json) => {
        var regionJson = mergeJsonByRegion(json);
        console.log(regionJson); //output to console to save data
        return convertGeometryToFeatures(regionJson, 'topojson');
    };

    const fetchGeometry = async () => {
        setLoadStatus(0);
        const DS = new DevDataService();
        const json = await DS.getGeometryData({ scope: 'state' }).then((data) => data[0]);

        const shapes = mergedRegionFeatures(json);

        setFeatures(shapes);
        setLoadStatus(1);
    };

    useEffect(() => map && fetchGeometry(), [map]);
    useEffect(() => map && setStyle(zoom > 6 ? outlineRegion : outlineRegionLow));
    useEffect(() => {
        for (let shape of features) {
            if (shape.get('id') === downloadRegion) {
                shape.setStyle(style);
            } else {
                shape.setStyle(null);
            }
        }
    }, [style, downloadRegion, features]);

    return <VectorLayer title={'States'} style={style} features={features} zIndex={zIndex} map={map} />;
};
export { RegionLayer };
